// import {
//   BarChart,
//   Bar,
//   ResponsiveContainer,
//   XAxis,
// } from "recharts";

// const data = [
//   { name: "Jan", created: 40, completed: 80 },
//   { name: "Feb", created: 30, completed: 90 },
//   { name: "Mar", created: 60, completed: 70 },
// ];

// export default function JobPerformance() {
//   return (
//    <>


//       {/* Stats */}
//        <div class="row mb-3">
//                         <div class="col">
//                           <div class="label ct_fs_12 ct-fw_400 ct_text_para">
//                             AVG COMPLETION
//                           </div>
//                           <div class="value ct_fs_18 ct_fw_700 ct_text_dark">
//                             4.2{" "}
//                             <span class="label ct_fs_12 ct_fw_400 ct_text_para">
//                               days
//                             </span>
//                           </div>
//                         </div>

//                         <div class="col">
//                           <div class="label  ct_fs_12 ct-fw_400 ct_text_para">
//                             DELAYED JOBS
//                           </div>
//                           <div class="value ct_danger_text ct_fs_20 ct_fw_700">
//                             05
//                           </div>
//                         </div>
//                       </div>

//                       <div class="d-flex justify-content-between mb-2">
//                         <div class="label ct_fs_10 ct_fw_700 ct_text_para">
//                           CREATED VS COMPLETED
//                         </div>
//                         <div class="efficiency ct_fs_10 ct_fw_700 ct_text_dark">
//                           88% EFFICIENCY
//                         </div>
//                       </div>

//       {/* Chart */}
//       <ResponsiveContainer width="100%" height={120}>
//         <BarChart data={data}>
//           <XAxis dataKey="name" hide />
          
//           {/* Created */}
//           <Bar
//             dataKey="created"
//             fill="#CBE7EF"
//             radius={[6, 6, 0, 0]}
//             barSize={20}
//           />

//           {/* Completed */}
//           <Bar
//             dataKey="completed"
//             fill="#2F5B7C"
//             radius={[6, 6, 0, 0]}
//             barSize={20}
//           />
//         </BarChart>
//       </ResponsiveContainer>
//          </>
//   );
// }

// import {
//   BarChart,
//   Bar,
//   ResponsiveContainer,
//   XAxis,
//   Cell,
//   Tooltip,
// } from "recharts";

// export default function JobPerformance({ data = [] }) {
//   const totalJobs = data.reduce((sum, item) => sum + item.value, 0);

//   const completedJobs =
//     data.find((item) => item.label === "Completed")?.value || 0;

//   const overdueJobs =
//     data.find((item) => item.label === "Overdue")?.value || 0;

//   const efficiency = totalJobs
//     ? ((completedJobs / totalJobs) * 100).toFixed(0)
//     : 0;

//   return (
//     <>
//       {/* Stats */}
//       <div className="row mb-3">
//         <div className="col">
//           <div className="label ct_fs_12 ct-fw_400 ct_text_para">
//             COMPLETED JOBS
//           </div>
//           <div className="value ct_fs_18 ct_fw_700 ct_text_dark">
//             {completedJobs}
//           </div>
//         </div>

//         <div className="col">
//           <div className="label ct_fs_12 ct-fw_400 ct_text_para">
//             OVERDUE JOBS
//           </div>
//           <div className="value ct_danger_text ct_fs_20 ct_fw_700">
//             {overdueJobs}
//           </div>
//         </div>
//       </div>

//       <div className="d-flex justify-content-between mb-2">
//         <div className="label ct_fs_10 ct_fw_700 ct_text_para">
//           JOB STATUS
//         </div>

//         <div className="efficiency ct_fs_10 ct_fw_700 ct_text_dark">
//           {efficiency}% COMPLETED
//         </div>
//       </div>

//       {/* Chart */}
//       <ResponsiveContainer width="100%" height={120}>
//         <BarChart data={data}>
//           <XAxis
//             dataKey="label"
//             tick={{ fontSize: 10 }}
//           />

//           <Tooltip />

//           <Bar
//             dataKey="value"
//             radius={[6, 6, 0, 0]}
//             barSize={35}
//           >
//             {data.map((entry, index) => (
//               <Cell
//                 key={index}
//                 fill={entry.color}
//               />
//             ))}
//           </Bar>
//         </BarChart>
//       </ResponsiveContainer>
//     </>
//   );
// }

import {
  BarChart,
  Bar,
  ResponsiveContainer,
  XAxis,
  Cell,
  Tooltip,
} from "recharts";

export default function JobPerformance({ data }) {
  const summary = data?.summary || {};
  const chartData = data?.chart_data || [];

  return (
    <>
      {/* Stats */}
      <div className="row mb-3">
        <div className="col">
          <div className="label ct_fs_12 ct-fw_400 ct_text_para">
            TOTAL JOBS
          </div>
          <div className="value ct_fs_18 ct_fw_700 ct_text_dark">
            {summary?.total_jobs || 0}
          </div>
        </div>

        <div className="col">
          <div className="label ct_fs_12 ct-fw_400 ct_text_para">
            DELAYED JOBS
          </div>
          <div className="value ct_danger_text ct_fs_20 ct_fw_700">
            {String(summary?.overdue || 0).padStart(2, "0")}
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between mb-2">
        <div className="label ct_fs_10 ct_fw_700 ct_text_para">
          JOB STATUS
        </div>

        <div className="efficiency ct_fs_10 ct_fw_700 ct_text_dark">
          {summary?.completion_rate || 0}% EFFICIENCY
        </div>
      </div>

      {/* Chart */}
      <ResponsiveContainer width="100%" height={140}>
        <BarChart data={chartData}>
          <XAxis
            dataKey="label"
            tick={{ fontSize: 10 }}
          />

          <Tooltip
            formatter={(value, name, props) => [
              value,
              `${props.payload.percent}%`,
            ]}
          />

          <Bar
            dataKey="value"
            radius={[6, 6, 0, 0]}
            barSize={30}
          >
            {chartData.map((entry, index) => (
              <Cell
                key={index}
                fill={entry.color}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </>
  );
}